// extracted by mini-css-extract-plugin
export default {"roleWrapper":"roles_roleWrapper__L8TDL","componentHeading":"roles_componentHeading__7y8cR","heading":"roles_heading__jfAew","addRoleBtn":"roles_addRoleBtn__-gzOO"};